import React from "react";
import {
  View,
  ScrollView,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from "react-native";

import ImageComponent from "../../../common/ImageComponent";
import AppTheme from "../../../AppTheme";
import appStyles from "../../../../appStyles";
import integrationStyles from "../../onboarding/integrationStyles";
import { openURL, isWeb } from "../../../../../helpers/utils";
import CopyWidget from "../../common/CopyWidget";

export default function DownloadStarted({ onButtonPress = () => {} }) {
  const url = "chrome://extensions/";

  return (
    <ScrollView
      style={(appStyles.scrollView, { paddingHorizontal: 16 })}
      contentContainerStyle={appStyles.scrollViewContent}
    >
      <Text style={styles.sectionText}>
        Great! {isWeb ? "The Chrome extension is downloading now" : "Please follow the download instructions in the email you received"}.
      </Text>

      <Text style={styles.label}>Installation Instructions:</Text>

      <Text style={styles.text}>
        1. Once download finishes, unpack .zip File
      </Text>
      <Text style={[styles.text, { marginTop: 8 }]}>
        2. Copy the link below into your browser:
      </Text>

      <CopyWidget
        text={url}
        style={{
          marginTop: 8,
          marginBottom: 16,
        }}
      />

      <Text style={[styles.text, { marginBottom: 8 }]}>
        3. Set the Developer mode (on top right) to “On”
      </Text>

      <View
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ImageComponent
          image={require("../../../../../assets/integrations/chromeInstructions.png")}
          style={{
            height: 71,
          }}
        />
      </View>

      <Text style={[styles.text, { marginVertical: 16 }]}>
        4. Click “Load unpacked,” browse and select the folder where the plugin
        was unpacked
      </Text>

      <Text style={styles.text}>
        5. If it was previously installed, and you want to install a newer
        version, click Update
      </Text>

      <View style={[integrationStyles.buttons]}>
        <TouchableOpacity
          onPress={onButtonPress}
          style={integrationStyles.greenButton}
        >
          <Text style={integrationStyles.greenButtonText}>{"Done"}</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginBottom: 8,
    marginTop: 16,
  },
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  linkText: {
    color: AppTheme.DEFAULT_COLOR,
    fontWeight: "600",
    marginTop: 16,
    marginBottom: 8,
  },
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    marginTop: 32,
    textAlign: "center",
  },
});
